<template>
    <div class="video_wrap">
        <video :src="src" :poster="poster" :class="{bg_video: isBg, video: !isBg}" ref="video" :autoplay="autoplay" :loop="loop" @play="play" @pause="pause" @ended="ended" x5-playsinline="" playsinline="" webkit-playsinline="" :muted="muted"></video>
        <VrControls type="home" :playing="playing" @play="$refs.video.play()" @pause="$refs.video.pause()"/>
    </div>
</template>

<script>
import VrControls from './vrControls.vue';
export default {
    name: "homeNormalVideo",
    props: ['src', 'poster', 'muted', 'autoplay', 'loop', 'isBg'],
    data() {
        return {
            playing: false,
        };
    },
    computed: {},
    components: {
        VrControls
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        play() { 
            this.playing = true;
            this.$emit('play');
        },
        pause() { 
            this.playing = false;
            this.$emit('pause');
        },
        ended() { 
            this.playing = false;
            this.$emit('ended');
        }
    },
};
</script>

<style scoped lang="scss">
.video_wrap{
    width: 100%;
    height: 100%;
    background: url('~@/assets/images/bgggg.jpg') no-repeat center/100%;
    position: relative;
}
.bg_video{
    min-width: 100%;
    min-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media only screen and (max-width: 640px) {
        position: relative;
    }
    @media only screen and (max-width: 640px) {
        width: 100%;
        min-height: auto;
        top: 0;
        left: 0;
        transform: none;
    }
}
.video{
    width: auto;
    max-width: 100%;
    height: 100%;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
    @media only screen and (max-width: 640px) {
        width: 100%;
        height: auto;
    }
}
</style>